import { GlobalBaseData } from "@sphtech/dmg-design-system";
import { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import ArticleLayout from "@src/app/layouts/Article/ArticleLayout";
import ErrorLayout from "@src/app/layouts/ErrorLayout/ErrorLayout";
import { StoryData } from "@src/app/types/ServerCustomContext";
import { useLoaderData, useRouteLoaderData } from "react-router";

export function StoryPage() {
  const response: TRouteWithoutRedirect<StoryData | null, string> =
    useLoaderData();
  const rootData: GlobalBaseData | undefined = useRouteLoaderData("root");

  if (response.statusCode !== 200 || !response.payload) {
    return <ErrorLayout response={response} />;
  }

  const globalData = rootData;

  const userSubmissionBox =
    globalData &&
    globalData.userSubmissionBox?.showOn.storiesWithTagSlugs?.some((tagSlug) =>
      response.payload?.tags.some((tag) => tag.slug === tagSlug),
    )
      ? globalData.userSubmissionBox
      : undefined;

  return (
    <ArticleLayout
      storyData={response.payload}
      userSubmissionBox={userSubmissionBox}
    />
  );
}
